<template>
  <div id="rp-property-inquiries">
    <View direction="column" gap="md">
      <Text variant="h3">
        <span>Property Inquiries</span>
        <Text variant="h3" as="span" color="tertiary" v-if="propertyInquiries.length">
          ({{ propertyInquiries.length }})
        </Text>
      </Text>

      <div class="property-inquiries-container">
        <RenterProfilePropertyInquiry
          v-for="inquiry in propertyInquiries"
          :property-inquiry="inquiry"
          :renter="renter!"
          @open-conversation-clicked="showConversation(inquiry.id)"
        />
      </div>
    </View>

    <RenterConversationModal ref="renterConversationModalRef" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { Text, View } from '@tallo/design-system';
import { useRenterInquiriesQuery } from '@tallo/investor/renter';

import { useRenterProfileStore } from '../store/renter-profile.store';
import RenterConversationModal from './renter-conversation-modal.vue';
import RenterProfilePropertyInquiry from './renter-profile-property-inquiry.vue';

const renterProfileStore = useRenterProfileStore();
const renterConversationModalRef = ref<InstanceType<typeof RenterConversationModal>>();

const inquiriesQuery = useRenterInquiriesQuery();

const propertyInquiries = computed(() => inquiriesQuery.data.value || []);
const renter = computed(() => renterProfileStore.getRenterProfile);

function showConversation(inquiryId: string) {
  renterConversationModalRef.value?.show(inquiryId);
}
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.property-inquiries-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--t-spacing-md);

  @include screen-min-md {
    grid-template-columns: repeat(2, 1fr);
  }

  @include screen-min-lg {
    grid-template-columns: 1fr;
  }
}
</style>
